import { useAuth } from '../AuthContext';
import { useUserProfile } from '../contexts/nobishiro-dashboard/useUserProfile';

export const PLAN_LIMITS = {
    free: {
        plateauDiagnosisPerWeek: 2, // 月2回（認知拡大フェーズ向け）
        plateauDetailedAnalysis: false,
        plateauHistoryLimit: 3,
        lawsAccessCount: 10,
        hasGrowthTypeDiagnosis: 'once',
        hasLearningPlan: false,
        hasReminder: false,
        hasGrowthPattern: false,
        hasGrowthPrediction: false,
        hasDataExport: false,
        hasAICoaching: true,
        aiCoachingMonthlyLimit: 3,
        hasPrioritySupport: false,
    },
    student: {
        plateauDiagnosisPerWeek: -1, // Unlimited
        plateauDetailedAnalysis: true,
        plateauHistoryLimit: -1,
        lawsAccessCount: 20,
        hasGrowthTypeDiagnosis: true,
        hasLearningPlan: true,
        hasReminder: true,
        hasGrowthPattern: false,
        hasGrowthPrediction: false,
        hasDataExport: false,
        hasAICoaching: true,
        aiCoachingMonthlyLimit: 10,
        hasPrioritySupport: false,
    },
    standard: {
        plateauDiagnosisPerWeek: -1,
        plateauDetailedAnalysis: true,
        plateauHistoryLimit: -1,
        lawsAccessCount: 40,
        hasGrowthTypeDiagnosis: true,
        hasLearningPlan: true,
        hasReminder: true,
        hasGrowthPattern: true,
        hasGrowthPrediction: true,
        hasDataExport: true,
        hasAICoaching: true,
        aiCoachingMonthlyLimit: 20,
        hasPrioritySupport: false,
    },
    business: {
        plateauDiagnosisPerWeek: -1,
        plateauDetailedAnalysis: true,
        plateauHistoryLimit: -1,
        lawsAccessCount: 40,
        hasGrowthTypeDiagnosis: true,
        hasLearningPlan: true,
        hasReminder: true,
        hasGrowthPattern: true,
        hasGrowthPrediction: true,
        hasDataExport: true,
        hasAICoaching: true,
        aiCoachingMonthlyLimit: -1,
        hasPrioritySupport: true,
    }
};

export const useSubscription = () => {
    const { user } = useAuth();
    const { profile, loading } = useUserProfile(user?.uid);

    const planId = profile?.subscription?.planId || 'free';
    const limits = PLAN_LIMITS[planId] || PLAN_LIMITS['free'];

    return {
        plan: planId,
        limits,
        loading,
        isFree: planId === 'free',
        isStudent: planId === 'student',
        isStandard: planId === 'standard',
        isBusiness: planId === 'business',
        isPaid: planId !== 'free',
        canAccessTeam: planId === 'business', // As per instructions, only Business has team features (Part 2)
        canAccessAllLaws: limits.lawsAccessCount >= 40
    };
};
